<style>
        .tbl-lead-info-left tr td:nth-child(1) {
            font-weight: bold;
            width: 125px;
        }
        
        .tbl-lead-info-right tr td:nth-child(1) {
            font-weight: bold;
            width: 125px;
        }
    </style>
    <div class="modal-primary" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Pending Lead</h4>
                <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="card">
                    <div class="card-body">
                        <!-- <h5 class="card-title">Lead Activity</h5> -->
                        <table class="table"  *ngIf="leadNoticationDetails.length > 0">
                            <thead>
                                <tr>
                                    <th>Business Name</th>
                                    <th>Contact Name</th>
                                    <th>Phone</th>
                                    <th>RSE Name</th>
                                    <th>Days</th>
                                    <th>Created At</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let leadNotication of leadNoticationDetails; let i = index">
                                <tr>                                    
                                    <td>{{leadNotication.business_name}}</td>
                                    <td>{{leadNotication.contact_name}}</td>
                                    <td>{{leadNotication.phone}}</td>
                                    <td>{{leadNotication.name}}</td>
                                    <td>{{leadNotication.days}}</td>
                                    <td>{{leadNotication.created_at | dateFormat }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="leadNoticationDetails.length==0">No Data Found</div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Close</button>
            </div>
        </div>



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/lead-notication-detail.html